import axios from "axios";
import { notify } from "./authApi";
import { API_BASE_URL } from "../utils/constants";
import { navigateTo } from "../utils/navigationUtils";

const apiClient = axios.create({
  baseURL: API_BASE_URL, 
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      switch (status) {
        case 401:
          notify("Session expired. Please log in again.");
          localStorage.removeItem("token");
          localStorage.removeItem("email");
          navigateTo("/login")
          break;

        case 403:
          notify("You don't have permission to perform this action.");
          break;

        case 404:
          notify("The requested resource was not found.");
          break;

        case 500:
          notify("Internal server error. Please try again later.");
          break;

        default:
          notify("An unexpected error occurred. Please try again.");
      }
    } else {
      notify("Network error. Please check your connection.");
    }
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
